<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>권한 관리</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          운영자
        </li>
        <li class="breadcrumb-item active"></li>
          <a href="/sso/roleList">권한 관리</a>
      </ol>
    </div>

    <!-- 상세 -->
    <div class="card card-default">
      <!--<div class="card-header">상세</div>-->
      <div class="card-body">
        <div class="text-bold h4 mt-2">권한 정보</div>
        <form data-vv-scope="edit">
          <table class="table table-bordered">
            <colgroup>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
            </colgroup>
            <tr>
              <th>이름 *</th>
              <td>
                <input :class="{'form-control':true, 'is-invalid': errors.has('edit.roleNm')}"
                  v-model="info.data.roleNm" v-validate="'required|min:2'" type="text" name="roleNm"
                  style="width: 200px"/>
              </td>
              <th>사용여부 *</th>
              <td>
                <b-input-group>
                  <div>
                    <b-form-select v-model="info.data.useYn" :options="useYnOption.noEmptyArray"></b-form-select>
                  </div>
                </b-input-group>
              </td>
            </tr>
            <tr>
              <th>비고(설명)</th>
              <td colspan="3">
                <input :class="{'form-control':true, 'is-invalid': errors.has('edit.roleDesc')}"
                  v-model="info.data.roleDesc" v-validate="'min:2'" type="text" name="roleDesc"
                  style="width: 100%"/>
              </td>
            </tr>
          </table>
        </form>
      </div>

      <div class="card-body">
        <div class="text-bold h4 mt-2">권한 메뉴 정보</div>
        <table class="table table-bordered table-hover">
          <colgroup>
            <col width="15%" class="bg-lightdark"/>
            <col width="85%"/>
          </colgroup>
          <thead>
            <tr class="bg-lightdark">
              <th class="text-center bg-gray-lighter">메뉴</th>
              <th class="text-center bg-gray-lighter">메뉴상세</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in info.data.menuList" :key="item.menuSeq">
              <th class="text-center bg-gray-lighter">{{item.menuNm}}</th>
              <td>
                <input @change="selectedMenuChanged(index, true)" type="checkbox" :id="`menu_${item.menuSeq}_all`" v-model="item.isSelectedAll"/>
                <label class="form-check-label ml-1 text-bold text-info" :for="`menu_${item.menuSeq}_all`">전체</label>
                <span class="ml-3"></span>
                <template v-for="(subItem) in item.subMenuList">
                  <input @change="selectedMenuChanged(index)" :key="`input_${subItem.menuSeq}`" class="ml-3" type="checkbox" :id="`menu_${subItem.menuSeq}`" v-model="item.selectedMenus" :value="subItem.menuSeq"/>
                  <label :key="`label_${subItem.menuSeq}`" class="form-check-label ml-1" :for="`menu_${subItem.menuSeq}`">{{subItem.menuNm}}</label>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="card-footer">
        <div class="card-tool float-right">
          <b-button @click="save(isEdit)" class="btn btn-s btn-outline-info mr-2" variant="outline-info">{{isEdit?'수정':'등록'}}</b-button>
          <!--<b-button @click="remove()" class="btn btn-s btn-outline-info mr-2" variant="outline-info mr-2">삭제</b-button>-->
          <b-button @click="goList()" class="btn btn-s btn-outline-info mr-2" variant="outline-info">목록</b-button>
        </div>
      </div>
    </div>
    <!-- // 상세 -->
    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import * as roleApi from "@/api/sso/SsoRoleApi";
import {dataObject, useYnOption, roleTypeOption, acntStatCd} from "@/utils/Constants";

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {Loading},
  props: {
    roleSeq : {
      type:Number|String,
      default:0,
    }
  },
  setup(props, {root}) {
    const modalLoading = ref(false);
    const info = reactive({data:{}});

    if (props.roleSeq instanceof String) {
      props.roleSeq = parseInt(props.roleSeq);
    }
    const _isEdit = props.roleSeq > 0;
    const isEdit = ref(_isEdit);
    const title = computed(() => {return _isEdit ? '권한 수정' : '권한 등록'});

    const retVals = {
      modalLoading,
      isEdit,
      title,
      info,
      roleTypeOption,
      useYnOption,
      ...methods(),
      router:root.$router,
    }
    onMounted(async () => {
      retVals.modalLoading.value = true;
      await retVals.detail(props.roleSeq);
      retVals.modalLoading.value = false;
    });

    return retVals;
  },
}

function methods() {

  // 상세
  async function detail(roleSeq){
    try {
      const result = await roleApi.getSsoRoleItem(roleSeq);
      if (result.data) {
        this.info.data = result.data;
        const menuList = this.info.data.menuList;
        menuList.forEach(menu => {
          if (menu.menuUri) {
            const subMenu = _.cloneDeep(menu);
            subMenu.subMenuList = [];
            menu.subMenuList.splice(0, 0, subMenu);
          }
          if (menu.subMenuList.length > 0) {
            menu.selectedMenus = menu.subMenuList.filter(subMenu => subMenu.included)
              .map(subMenu => subMenu.menuSeq);
          } else {
            menu.selectedMenus = [];
          }
          menu.isSelectedAll = menu.subMenuList.length ? menu.subMenuList.length == menu.selectedMenus.length : false;
        });
      } else {
        this.router.push('/sso/roleList');
      }
    } catch (e) {
      if (e.data && e.data.message) {
        alert(e.data.message);
      }
      this.router.push('/sso/roleList');
    }
  }

  function selectedMenuChanged(index, all) {
    const menuList = _.cloneDeep(this.info.data.menuList);
    const menu = menuList[index];
    const allSubMenus = menu.subMenuList.map(subMenu => subMenu.menuSeq);
    if (all) {
      if (menu.isSelectedAll) {
        menu.selectedMenus = allSubMenus;
      } else {
        menu.selectedMenus = [];
      }
    } else {
      menu.isSelectedAll = menu.selectedMenus.length == allSubMenus.length;
    }
    // menuList 의 reference 값 자체를 수정해야 Vue 에서 menuList 내부의 값 변경이 감지된다.
    this.info.data.menuList = menuList;
  }

  async function save(isEdit) {
    const isValid = await this.$validator.validateAll('edit');
    if (!isValid) {
      alert('필수 입력 항목을 확인해주세요.');
      return;
    }
    const editMessage = isEdit ? '수정' : '등록';
    if (!confirm(`권한정보를 ${editMessage}하시겠습니까?`)) {
      return;
    }

    let selectedMenus = [];
    this.info.data.menuList.forEach((menu) => {
      selectedMenus.push(...menu.selectedMenus);
    });
    if (selectedMenus.length == 0) {
      if (!confirm(`선택된 메뉴가 없습니다. 그래도 ${editMessage}하시겠습니까?`)) {
        return;
      }
    }
    const params = {
      roleSeq : this.info.data.roleSeq,
      roleNm : this.info.data.roleNm,
      useYn : this.info.data.useYn,
      roleDesc : this.info.data.roleDesc,
      menuSeqs : selectedMenus.join(',')
    }
    console.log('save:', params);

    const result = await roleApi.saveSsoRole(params);
    const retMessage = isEdit ? '수정했습니다.' : '등록했습니다.';
    alert(retMessage);
    if (!isEdit) {
      this.goList();
    }
  }

  async function goList() {
    this.$router.push('/sso/roleList');
  }

  return {detail, selectedMenuChanged, save, goList}
}

</script>